import { Fragment } from "react";
import Menu from "./Menu";
import { Dialog, Transition } from "@headlessui/react";

const MenuModal = (props) => {
  return (
    <Transition appear show={props.isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={props.openHandler}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed top-0 left-0 inset-0 bg-indigo-900 backdrop-blur-sm bg-opacity-90 z-10" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto z-20">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel onClick={props.openHandler}>
                <Menu
                  info={props.info}
                  onActive={props.onActive}
                  activeHandler={props.activeHandler}
                  navMenu={props.navMenu}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default MenuModal;
